<template>
    <div>
        <div class="columns" id="table">
            <past-auction-mobile
                    v-if="isMobile"
                    v-for="(lot, index) in results"
                    :lot="lot"
                    :index="index"
                    v-bind:key="index">
            </past-auction-mobile>
            <div v-if="!isMobile" class="column">
                <div class="theme-table-container table-container center-column">
                    <table class="auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth">
                        <thead>
                        <tr class="top-header">
                            <th></th>
                            <th><span class="link" @click="orderBy('AUCTION_DATE')">Date</span></th>
                            <th><span class="link" @click="orderBy('AUCTION')">Place</span></th>
                            <th><span class="link" @click="orderBy('MODEL_NAME')">Model</span></th>
                            <th></th>
                            <th><span class="link" @click="orderBy('KUZOV')">Chassis</span></th>
                            <th><span class="link" @click="orderBy('MILEAGE')">Mileage</span></th>
                            <th><span class="link" @click="orderBy('COLOR')">Color</span></th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr class="bottom-header">
                            <th>Photo</th>
                            <th><span class="link" @click="orderBy('AUCTION_DATE')">Time</span></th>
                            <th><span class="link" @click="orderBy('LOT')">Lot No</span></th>
                            <th><span class="link" @click="orderBy('GRADE')">Grade</span></th>
                            <th><span class="link" @click="orderBy('YEAR')">Year</span></th>
                            <th><span class="link" @click="orderBy('ENG_V')">Engine Size</span></th>
                            <th><span class="link" @click="orderBy('KPP')">Transmission</span></th>
                            <th><span class="link" @click="orderBy('RATE')">Score</span></th>
                            <th><span class="link" @click="orderBy('START')">Start/Price</span></th>
                            <th><span class="link" @click="orderBy('FINISH')">Result</span></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="result in results">
                                <td class="picture-td">
                                    <figure class="image is-65x65"  @click="openGallery(result)">
                                        <img :src="result.IMAGES.split('#')[0]">
                                    </figure>
                                </td>
                                <td>
                                    {{ result.AUCTION_DATE.split(' ')[0] }}<br>
                                    {{ result.AUCTION_DATE.split(' ')[1] }}
                                </td>
                                <td>
                                    {{ result.AUCTION }}<br>
                                    {{ result.LOT }}
                                </td>
                                <td>
                                    {{ result.MODEL_NAME }}<br>
                                    <span v-html="result.GRADE"></span>
                                </td>
                                <td>{{ result.YEAR }}</td>
                                <td>
                                    {{ result.KUZOV }}<br>
                                    {{ result.ENG_V }}
                                </td>
                                <td>
                                    {{ result.MILEAGE | formatNumber }}<br>
                                    {{ result.KPP }}
                                </td>
                                <td>
                                    {{ result.COLOR }}<br>
                                    {{ result.RATE }}
                                </td>
                                <td>
                                    {{ result.START | formatNumber }}
                                </td>
                                <td>
                                    {{ result.STATUS }}<br>
                                    {{ result.FINISH | formatNumber }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>
        </div>
        <div class="columns">
            <div class="column">
                <div class="has-text-centered">
                    <button class="button is-large"
                            @click.prevent="loadMore()">
                        <span>Load More</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Gallery from '../Result/Gallery'
    import PastAuctionMobile from "./PastAuctionMobile";
    export default {
        components: {
            PastAuctionMobile,
            Gallery
        },
        data() {
            return {

            }
        },
        computed: {
            results() {
                return this.$store.getters.getStatsResult
            },
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        },
        methods: {
            orderBy(column){
                this.$store.getters.getStatsQuery.order_type === 'ASC' ? this.$store.dispatch('setStatsQueryFieldValue', {field: 'order_type', value: 'DESC'}) : this.$store.dispatch('setStatsQueryFieldValue', {field: 'order_type', value: 'ASC'})
                this.$store.dispatch('setStatsQueryFieldValue', {field: 'order_column', value: column })
                this.$store.dispatch('fetchStatsResult')
            },
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            openGallery(result) {
                this.$store.dispatch('setResultGalleryItems', [result.IMAGES.split('#')[0].slice(0, -5), result.IMAGES.split('#')[1].slice(0, -5)] )
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            loadMore() {
                this.$store.dispatch('loadMoreStatsResults')
            }
        },
    }
</script>

<style scoped>
    th {
        font-size: 10px;
    }
    .top-header th {
        border-bottom: none;
        background-color: whitesmoke;
    }
    .bottom-header th {
        border-top: none;
        background-color: whitesmoke;
    }
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .image {
        cursor: pointer;
    }
    .link:hover {
        cursor: pointer;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/PastAuctions/PastAuctionTable.vue